import styled from "styled-components";

const FormHeader = styled("div")`
    border-bottom: 1px solid #e5e5e5;
    color: #333;
    font-size: 25px;
    font-weight: 400;
    margin: 0 15px;
    padding: 30px 0 15px;

    ${(props) => props.theme.breakpoints.up("desktop")} {
        font-size: 30px;
        margin: 0 40px;
    }
`;
export default FormHeader;
